import { useEffect } from 'react'

import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import BrandFansGroupRow from '@components/BrandFans/Group/Row'
import Loading from '@components/UI/Loading'
import { BrandFanFilters } from '@enums'
import { IApplicationState } from '@store'
import {
  fetchBrandFanGroups,
  selectBrandFanGroupIds,
  selectBrandFanGroupsNextLink,
  selectIsFetchingInitialBrandFanGroupList,
  selectIsListEmpty,
} from '@store/brandFans'
import { Container } from '@tribegroup'
import InfluencerIdentityListEmpty from '../../InfluencerIdentity/List/Empty'

const InfluencerIdentityGroupList: React.FC = () => {
  const { groupIds, isEmptyList, isLoadingInitialList, hasNextLink } = useSelector(
    (state: IApplicationState) => ({
      isEmptyList: selectIsListEmpty(state, BrandFanFilters.Groups),
      isLoadingInitialList: selectIsFetchingInitialBrandFanGroupList(state),
      groupIds: selectBrandFanGroupIds(state),
      hasNextLink: selectBrandFanGroupsNextLink(state),
    }),
    shallowEqual,
  )
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchBrandFanGroups())
  }, [])

  if (isLoadingInitialList) {
    return <Loading height={30} />
  }

  if (isEmptyList) {
    return <InfluencerIdentityListEmpty type={BrandFanFilters.Groups} />
  }

  const onScroll = (event: React.UIEvent<HTMLElement>) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5

    if (isAtBottom && hasNextLink) {
      dispatch(fetchBrandFanGroups(true))
    }
  }

  return (
    <Container
      topOuterSpacing={3.75}
      bottomInnerSpacing={4.5}
      onScroll={onScroll}
      maxHeight={'calc(100vh - 26rem)'}
      overflow="auto"
    >
      <div data-testid="brand-fans-groups-list">
        {groupIds.map((id) => (
          <BrandFansGroupRow key={id} groupId={id} />
        ))}
      </div>
    </Container>
  )
}

export { InfluencerIdentityGroupList }
export default InfluencerIdentityGroupList
